import React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { selectLogin } from 'store/slices/auth/authSlice';
import { useSelector } from 'react-redux';
import Button from 'react-bootstrap/Button';
import './styles.scss';
import Logo from 'pub-components/Sidebar/Logo';
import { AppMetaProvider } from 'pub-components/Sidebar/helper';
import Tracker from 'app/tracking/tracking-service';
import { Enums } from 'services/dropdown-enums';
import { useEffect } from 'react';
import { selectRoles } from 'store/slices/roles/rolesSlice';
const NotFound = ({
  errorExpression = 'Ooops!!',
  errorCode = 404,
  message = 'THAT PAGE DOESN’T EXIST OR IS UNAVAILABLE.',
  goBack = false
}) => {
  const history = useHistory();
  const location = useLocation();
  const { roles } = useSelector(selectRoles);

  useEffect(() => {
    // call Tracker event for switchTo
    Tracker.EventsProvider(
      Enums.TrackerType.GoogleAnalytics
    ).Redirection.RedirectedTo404(location?.state?.prevPath || '');
  }, []);

  const isAuthenticated = useSelector(selectLogin).isAuthenticated;
  const { isWhiteLabeled } = AppMetaProvider().GetStaticMeta;
  return (
    <div className="container text-center">
      <div className="row d-flex full-height align-items-center justify-content-center">
        <div>
          <div
            className={`${
              isWhiteLabeled ? 'logo-onroll' : 'logo-apex'
            } d-flex justify-content-center logo404`}
          >
            <Link to="/">
              <Logo login />
            </Link>
          </div>
          <h4 className="mb-0 fw-600 mt-64">{errorExpression}</h4>
          <h1 className="fz-200 text-danger-1 fw-300 my-24">{errorCode}</h1>
          <h5 className="fw-500 mb-lg-64 mb-48">{message}</h5>
          {goBack || roles?.showLimitedAccessWarning ? (
            <Button className="btn btn-primary btn-lg" onClick={history.goBack}>
              Go Back
            </Button>
          ) : (
            <Link
              className="btn btn-primary btn-lg"
              to={isAuthenticated ? '/home' : '/login'}
            >
              Back to {isAuthenticated ? 'Home' : 'Login'}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
